import React from 'react';
import PropTypes from 'prop-types';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import validationFormsStyle from 'assets/jss/material-dashboard-pro-react/views/validationFormsStyle';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import UserChangePassword from 'components/User/ChangePassword';

const ScreenUserChangePassword = ({ classes }) => (
  <div className={classes.container}>
    <GridContainer justify="center">
      <GridItem xs={12} sm={8} md={8}>
        <UserChangePassword classes={classes} />
      </GridItem>
    </GridContainer>
  </div>
);

ScreenUserChangePassword.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(validationFormsStyle)(ScreenUserChangePassword);
